import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LatLngLiteral {
  lat: number;
  lng: number;
}

interface Map2State {
  accountId: string
  latitude: string
  longitude: string
  submitted: boolean
  boundary: LatLngLiteral[][][]
  source: string | null
}

const initialState: Map2State = {
  accountId: '',
  latitude: '',
  longitude: '',
  submitted: false,
  boundary: [],
  source: null
}

export const map2Slice = createSlice({
  name: 'map2',
  initialState,
  reducers: {
    setAccountId: (state, action: PayloadAction<string>) => {
      state.accountId = action.payload
    },
    setLatitude: (state, action: PayloadAction<string>) => {
      state.latitude = action.payload
    },
    setLongitude: (state, action: PayloadAction<string>) => {
      state.longitude = action.payload
    },
    setSubmitted: (state, action: PayloadAction<boolean>) => {
      state.submitted = action.payload
    },
    setBoundary: (state, action: PayloadAction<LatLngLiteral[][][]>) => {
      state.boundary = action.payload
    },
    setSource: (state, action: PayloadAction<string | null>) => {
      state.source = action.payload
    }
  }
})

export const { setAccountId, setLatitude, setLongitude, setSubmitted, setBoundary, setSource } = map2Slice.actions

export default map2Slice.reducer 